import { render, staticRenderFns } from "./SummaryEvent.vue?vue&type=template&id=8ad159e4"
import script from "./SummaryEvent.vue?vue&type=script&lang=js"
export * from "./SummaryEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports